import { gql } from '@edreamsodigeo/frontend-api-client';

export const create = gql`
  mutation createSB($request: CreateShoppingBasketRequest) @silent {
    createShoppingBasket(request: $request) {
      shoppingBasketId
    }
  }
`;

export const addContactDetails = gql`
  mutation addContactDetailsToShoppingBasket(
    $request: AddContactDetailsToShoppingBasketRequest
  ) @silent {
    addContactDetailsToShoppingBasket(request: $request)
  }
`;

export const get = gql`
  query getPFShoppingBasket($request: ShoppingBasketRequest) {
    getShoppingBasket(request: $request) {
      shoppingBasketId
      buyer {
        name
        lastNames
        mail
        phoneNumber {
          countryCode
          number
        }
      }
    }
  }
`;
